// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#ppes-list .ppe{margin-right:5px}#ppes-list .fa-envelope{font-size:1.7rem}.module-description-wrapper{background:rgba(255,193,7,0.1);border:1px solid rgba(0,0,0,0.1);padding:10px;margin-bottom:15px;width:100%}.module-description-wrapper h4{font-size:1.3rem;margin-bottom:0}.module-description-wrapper ul{margin:0}.module-description-wrapper li{font-size:1rem}body.sfr .module-description-wrapper,body.catsafe .module-description-wrapper{background:#F0F0F0}\n", ""]);
// Exports
module.exports = exports;
